/* tslint:disable */

/**
 * HR Portal API
 * HR Portal API
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime';
import {
    Attachment,
    AttachmentFromJSON,
    AttachmentToJSON,
} from './';

/**
 *
 * @export
 * @interface ContentItem
 */
export interface ContentItem {
    /**
     *
     * @type {string}
     * @memberof ContentItem
     */
    id: string;
    /**
     *
     * @type {string}
     * @memberof ContentItem
     */
    title: string;
    /**
     *
     * @type {boolean}
     * @memberof ContentItem
     */
    draft?: boolean;
    /**
     *
     * @type {Date}
     * @memberof ContentItem
     */
    updatedAt?: Date;
    /**
     *
     * @type {Array<string>}
     * @memberof ContentItem
     */
    labelNames?: string[];
    /**
     *
     * @type {string}
     * @memberof ContentItem
     */
    body?: string;
    /**
     *
     * @type {Array<Attachment>}
     * @memberof ContentItem
     */
    attachments?: Attachment[];
    /**
     *
     * @type {string}
     * @memberof ContentItem
     */
    coverImage?: string;
}

export function ContentItemFromJSON(json: any): ContentItem {
    return ContentItemFromJSONTyped(json, false);
}

export function ContentItemFromJSONTyped(json: any, _: boolean): ContentItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'id': json['id'],
        'title': json['title'],
        'draft': !exists(json, 'draft') ? undefined : json['draft'],
        'updatedAt': !exists(json, 'updated_at') ? undefined : (new Date(json['updated_at'])),
        'labelNames': !exists(json, 'label_names') ? undefined : json['label_names'],
        'body': !exists(json, 'body') ? undefined : json['body'],
        'attachments': !exists(json, 'attachments') ? undefined : ((json['attachments'] as any[]).map(AttachmentFromJSON)),
        'coverImage': !exists(json, 'cover_image') ? undefined : json['cover_image'],
    };
}

export function ContentItemToJSON(value?: ContentItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'id': value.id,
        'title': value.title,
        'draft': value.draft,
        'updated_at': value.updatedAt === undefined ? undefined : (value.updatedAt.toISOString()),
        'label_names': value.labelNames,
        'body': value.body,
        'attachments': value.attachments === undefined ? undefined : ((value.attachments as any[]).map(AttachmentToJSON)),
        'cover_image': value.coverImage,
    };
}
